// extracted by mini-css-extract-plugin
export default {"logo":"LogoBanner_logo__URoru","container":"LogoBanner_container__6F036","logoImage":"LogoBanner_logoImage__IcfyX","slide":"LogoBanner_slide__9BT0W"};